"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentActivityServiceClient = void 0;
var StudentActivityServiceClient_1 = require("./StudentActivityServiceClient");
Object.defineProperty(exports, "StudentActivityServiceClient", { enumerable: true, get: function () { return __importDefault(StudentActivityServiceClient_1).default; } });
//# sourceMappingURL=index.js.map